/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import './scss/custom.scss'
import { Index } from './views/Index/Index'
import { DebugPanel } from './arc/views/DebugPanel/DebugPanel'
import { ResponsePanel } from './arc/views/ResponsePanel/ResponePanel'
import { UserSessionConnected } from './arc/views/UserSession/UserSession'
import { CoverageDiscoveryRequestConnected } from './views/CoverageDiscoveryRequest/CoverageDiscoveryRequest'
import { RequestHistoryConnected } from './views/RequestHistory/RequestHistory'
import { BatchesConnected } from './views/Batches/Batches'
import { AccountFacilitiesConnected } from './views/AccountFacilities/AccountFacilities'
import { AccountFacilityDetailConnected } from './views/AccountFacilityDetail/AccountFacilityDetail'
import { ImportBatchUIConnected } from './views/ImportBatchUI/ImportBatchUI'
import { CoverageDiscoveryResponseConnected } from './views/CoverageDiscoveryHome/CoverageDiscoveryResponse/CoverageDiscoveryResponse'
import { container } from './arc/configuration/ServiceLocator'
import { IJwtStorage } from './arc/services/JwtStorage/contracts'
import { IUserSessionStateManager } from './arc/services/UserSessionStateManager/contracts'

const App: React.FunctionComponent = () => {
	let loginStatus = false
	const jwtStorage = container.get<IJwtStorage>('IJwtStorage')
	const userSessionStateManager = container.get<IUserSessionStateManager>('IUserSessionStateManager')
	const token = jwtStorage.getJwt()
	if (token && token !== '') {
		loginStatus = true
	}
	return (
		<Router basename={process.env.PUBLIC_URL}>
			{loginStatus ? (
				<div className="container esmdContainer">
					<ResponsePanel>
						<div className="row">
							<Route path="/" exact component={Index} />
							<CoverageDiscoveryRequestConnected />
							<RequestHistoryConnected />
							<BatchesConnected />
							<AccountFacilitiesConnected />
							<AccountFacilityDetailConnected />
							<CoverageDiscoveryResponseConnected />
							<ImportBatchUIConnected />
						</div>
					</ResponsePanel>
				</div>
			) : (
				userSessionStateManager.logOut()
			)}
			<DebugPanel />
			<UserSessionConnected />
		</Router>
	)
}

export default App
